import axios from "axios";
import compose from "ramda/src/compose";
import queryString from "query-string";
import _get from "lodash/get";
import * as Auth from "services/network/auth";
import { bypass } from "services/utils/fn";
import {
  logout,
  requestGrantCode,
  refreshAccessToken,
  setAccessToken,
} from "services/state/actions";
import store from "services/state/store";
import ENV from "../../../../../envProperties";
import OAuthService from "./OAuthService";

const PROTOCOL = "https";
const BASIC = ENV.API_SENSEDIA_BASIC_CUSTOM;
const CLIENT_ID = ENV.API_SENSEDIA_CLIENT_ID_CUSTOM;
const HOST = ENV.API_SENSEDIA;

const instance = axios.create({
  baseURL: `${PROTOCOL}://${HOST}`,
  headers: {
    "Accept-Language": "pt-BR",
    "Content-Type": "application/json",
    client_id: CLIENT_ID,
    Authorization: BASIC,
    access_token: "",
  },
});

const interceptors = { request: [], response: [] };

interceptors.request.push({
  success: (unused, request) => {
    request.headers.Authorization = BASIC;
    request.headers.access_token = Auth.getSensediaAccessToken().accessToken;
    const { baseURL, params, url } = request;

    if (request.download) {
      window.location = `${baseURL}${url}?${queryString.stringify(params)}`;
      return false;
    }
    return request;
  },
  error: (unused, error) => {
    Promise.reject(error);
  },
});

interceptors.response.push({
  success: (unused, response) => {
    if (!response) return; /* TODO: verificar se condição afeta o sistema */
    if (!response.data.access_token) return response;
    return compose(bypass(Auth.setSensediaAuthorization))(response);
  },
  error: ({ dispatch }, error) =>
    new Promise((resolve, reject) => {
      const httpStatus = error.response.status;
      if (httpStatus === 401 || httpStatus === 403) {
        const url = error.config.url.replace(error.config.baseURL, "");
        const method = error.config.method;
        const data = error.config.method === "post" ? error.config.data : null;

        if (url === "/oauth/grant-code" || url === "/oauth/access-code") {
          return dispatch(logout());
        }
        if (httpStatus === 401) {
          return dispatch(requestGrantCode({ resolve, ...error.config }));
        }

        if (httpStatus === 403) {
          return reject(error);
        }

        return dispatch(
          refreshAccessToken(Auth.getSensediaAccessToken().refreshToken, {
            url,
            data,
            method,
            resolve,
          })
        );
      }
      return reject(error);
    }),
});

instance.interceptors.response.use(
  (response) => response,
  (error) =>
    new Promise(async (resolve, reject) => {
      let finalData;
      const httpStatus = _get(error.response, "status", "");
      const previousMethod = _get(error.response, "config.method", "");
      const previousUrl = _get(error.response, "config.url", "");
      const previousData = _get(error.response, "config.data", "");
      if (httpStatus === 401 || httpStatus === 403) {
        const promise = new Promise((resolve2) => {
          OAuthService.requestSensediaToken()
            .then((data) => {
              const accessToken = _get(data, "access_token", "");
              const headersMap = {
                headers: {
                  "Content-Type": "application/json",
                  access_token: accessToken,
                  client_id: CLIENT_ID,
                },
              };
              store.dispatch(setAccessToken(data.access_token));

              OAuthService.repeatRequestSensedia(
                previousUrl,
                previousData,
                previousMethod,
                headersMap
              ).then((data2) => {
                finalData = data2;
                return resolve2(data2);
              });
            })
            .catch((err) => reject(err));
        });
        await Promise.all([promise]);
      }
      if (httpStatus === 400) {
        return reject(error);
      }
      return resolve(finalData);
    })
);

instance.interceptors.request.use((config) => {
  if (!config.headers.access_token || config.headers.access_token === "") {
    config.headers.access_token = store.getState().oAuthSensedia.sensediaToken;
  }
  if (!!store.getState().oAuthSensedia) {
    config.headers.access_token = store.getState().oAuthSensedia.sensediaToken;
  }
  return config;
});

export default { client: instance, options: { interceptors } };



// WEBPACK FOOTER //
// ./src/services/state/middlewares/axios/clients/sensediaCustom.js